/**
 * @generated SignedSource<<c1687305a1cbfd4db457002d6dee29e1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseRelatedDesignsContainer_photos$data = {
  readonly facets: {
    readonly imageRoomTypeFacet: ReadonlyArray<{
      readonly label: string | null;
      readonly name: string | null;
    } | null> | null;
    readonly imageStyleFacet: ReadonlyArray<{
      readonly label: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PhotosSearchBrowseRelatedDesignsContainer_photos";
};
export type PhotosSearchBrowseRelatedDesignsContainer_photos$key = {
  readonly " $data"?: PhotosSearchBrowseRelatedDesignsContainer_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseRelatedDesignsContainer_photos">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseRelatedDesignsContainer_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseFacets",
      "kind": "LinkedField",
      "name": "facets",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "imageRoomTypeFacet",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "imageStyleFacet",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "f5acef6df07a7c9791ef0d520745f54d";

export default node;
